exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-tree-branch {\n  display: table;\n  width: 100%;\n  padding-left: 1.4rem;\n}\n.fm-tree-branch li > p {\n  margin-bottom: 0.1rem;\n  padding: 0.4rem 0.4rem;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.fm-tree-branch li > p:hover, .fm-tree-branch li > p.selected {\n  background-color: #f8f9fa;\n}\n.fm-tree-branch .fas.fa-minus {\n  padding-left: 0.1rem;\n  padding-right: 0.6rem;\n}\n.fm-tree-branch .far {\n  padding-right: 0.5rem;\n}\n.fade-tree-enter-active, .fade-tree-leave-active {\n  transition: all 0.3s ease;\n}\n.fade-tree-enter, .fade-tree-leave-to {\n  transform: translateX(20px);\n  opacity: 0;\n}", ""]);

// exports
